const menu_container = document.querySelector('.main_menu_header');

if (menu_container) {
  menu_container.querySelector('.burger-icon').addEventListener('click', (e) => {
    e.preventDefault();
    menu_container.classList.toggle('active');
  })
}
